// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"a2c91711","639":"89843e67"}[chunkId] + ".chunk.js";
};